import React, { useCallback, useState, useEffect } from 'react';
import { Handle, Position } from '@xyflow/react';
import styled from 'styled-components';
import {
  Avatar,
  Button,
  Heading,
  Tooltip as SuperopsTooltip,
  TextStyle,
  Badge,
  Popover,
  ActionList,
  Banner,
  DisplayText,
  TextField
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import {
  getTranslatedText,
  COLOR_MAP,
  TEXT_LENGTH,
  RunbookNodeActivatorContent
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';

function AddStepNoteAction(props) {
  const { intl } = props;

  const formData = props?.data?.formData;
  const actionValueData = props?.data?.formData?.actionValueData;
  const parentActionId = props?.data?.formData?.parentActionId;

  const [stepName, setStepName] = useState(formData?.name || '');
  const hasActionId = props?.data?.formData?.actionId;
  const [popoverActive, setPopoverActive] = useState(Boolean(!hasActionId));

  const togglePopoverActive = () => {
    if (!hasActionId) {
      return;
    }
    setPopoverActive((active) => !active);
  };

  useEffect(() => {
    props?.data?.setPopoverState(props.id, popoverActive); // Update global state
  }, [popoverActive]);

  const activator = (
    <RunbookNodeActivatorContent
      nodeType="admin.runbooks.templateactions.requestnote"
      nodeName={stepName}
      iconName="NotesColoured"
      callBackFunction={(e) => {
        e.preventDefault();
        togglePopoverActive();
      }}
    />
  );

  const save = () => {
    const formData = {
      name: stepName || '',
      id: props.id,
      actionType: 'SINGLE',
      actionProcessCategory: 'SYNC',
      actionValueType: 'REQUEST_NOTE',
      actionValueData: {
        nodeId: props.id
        // checklist: {
        //   data: stepName
        // }
      }
    };
    if (hasActionId) {
      formData.actionId = hasActionId;
    }
    if (parentActionId) {
      formData.parentActionId = parentActionId;
    }
    props.modifyNodeData(formData);
    setPopoverActive(false);
  };

  const handleNodeDelete = () => {
    togglePopoverActive();
    props.data.handleNodeDelete(props.id, hasActionId);
  };

  return (
    <Popover
      active={popoverActive}
      activator={activator}
      preferredPosition="below"
      preferredAlignment="left"
      onClose={togglePopoverActive}
      fullHeight
    >
      <div className="p20 w400">
        <div className="canvas-bg">
          <Button
            plainSecondary
            id="statusChange"
            icon={<SVGIcon name="NotesColoured" />}
            size="large"
            onClick={togglePopoverActive}
          >
            <FormattedMessage id="admin.runbooks.templateactions.requestnote" />
          </Button>
        </div>

        <div className="mt-20">
          <TextField
            // label={getTranslatedText(intl, 'attribute.patchdescription')}
            label="Note Name"
            name="Note Name"
            maxLength={TEXT_LENGTH.size_3}
            value={stepName}
            onChange={setStepName}
            // placeholder={getTranslatedText(intl, 'attribute.patchdescription')}
            placeholder="Note Name"
            autoFocus
            focused
          />
        </div>

        <div className="flex g10 justify-end mt-20">
          <Button onClick={handleNodeDelete} icon={<SVGIcon name="Delete" />} />
          {/* <Button primary onClick={() => save(true)}>
            // {/* <FormattedMessage id="common.save" /> */}
          {/* Save and Add new */}
          {/* </Button> */}
          <Button primary onClick={() => save()} disabled={!stepName}>
            <FormattedMessage id="common.save" />
          </Button>
        </div>
      </div>
    </Popover>
  );
}

export default injectIntl(AddStepNoteAction);
